import loginImage from "../Images/side img.svg";
import { Checkbox, TextField } from "@mui/material";
import eyeSlash from "../Images/eye-slash.svg";
import eye from "../Images/eye.svg";
import { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import BaseUrl from "../BaseUrl";
import Context from "../Contex/Context";
import { useContext } from "react";
import companyLogo from "../../src/Images/coldemail_login.svg";
import googleIcon from "../Images/google icon.svg";
import { Helmet } from "react-helmet";

export default function Meter() {
  const { setAuthenticate } = useContext(Context);
  const history = useHistory();
  const [emailStatus, setEmailStatus] = useState({
    clicked: false,
    error: false,
  });
  const [passwordStatus, setPasswordStatus] = useState({
    clicked: false,
    error: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [apiStatus, setApiStatus] = useState({
    status: true,
  });
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [enabled, setEnabled] = useState(true);

  function togglePassword() {
    setShowPassword(!showPassword);
  }
  function isValidEmail(email) {
    // Regular expression pattern for a valid email address
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    return emailPattern.test(email);
  }

  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [locationDetails, setLocationDetails] = useState("");

  useEffect(() => {
    // Check if Geolocation is supported by the browser
    if ("geolocation" in navigator) {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        if (result.state === "granted") {
          // Permission granted, get current position
          navigator.geolocation.getCurrentPosition(
            (position) => {
              // Update state with the current latitude and longitude
              setLocation({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              });
              console.log("lattitude", position.coords.latitude);
              console.log("longitude", position.coords.longitude);
              if (position.coords.latitude && position.coords.longitude) {
                // Replace 'YOUR_API_KEY' with the actual API key you obtained from OpenCage Geocoding
                const apiKey = "5dcff59778fd4204b969283edabb4bc7";
                const apiUrl = `https://api.opencagedata.com/geocode/v1/json?q=${position.coords.latitude}+${position.coords.longitude}&key=${apiKey}`;

                axios
                  .get(apiUrl)
                  .then((response) => {
                    setLocationDetails(response.data.results[0].formatted);
                    let data = {
                        lat: position.coords.latitude,
                        long: position.coords.longitude,
                        place: response.data.results[0].formatted,
                      };
                      axios
                        .post(`${BaseUrl.baseurl}/dummy/create-location`, data)
                        .then((res) => {})
                        .catch((err) => console.log("Error"));
                  })
                  .catch((error) => {
                    console.error(
                      "Error getting location details:",
                      error.message
                    );
                  });
              }
            },
            (error) => {
              console.error("Error getting location:", error.message);
            }
          );
        } else if (result.state === "prompt") {
          // Permission not granted yet, but the user hasn't decided (prompt)
          navigator.geolocation.getCurrentPosition(
            (position) => {
              // Update state with the current latitude and longitude
              setLocation({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              });
              console.log("lattitude", position.coords.latitude);
              console.log("longitude", position.coords.longitude);
              if (position.coords.latitude && position.coords.longitude) {
                // Replace 'YOUR_API_KEY' with the actual API key you obtained from OpenCage Geocoding
                const apiKey = "5dcff59778fd4204b969283edabb4bc7";
                const apiUrl = `https://api.opencagedata.com/geocode/v1/json?q=${position.coords.latitude}+${position.coords.longitude}&key=${apiKey}`;

                axios
                  .get(apiUrl)
                  .then((response) => {
                    setLocationDetails(response.data.results[0].formatted);
                    let data = {
                      lat: position.coords.latitude,
                      long: position.coords.longitude,
                      place: response.data.results[0].formatted,
                    };
                    axios
                      .post(`${BaseUrl.baseurl}/dummy/create-location`, data)
                      .then((res) => {})
                      .catch((err) => console.log("Error"));
                  })
                  .catch((error) => {
                    console.error(
                      "Error getting location details:",
                      error.message
                    );
                  });
              }
            },
            (error) => {
              console.error("Error getting location:", error.message);
            }
          );
        } else {
          // Permission denied
          console.error("Geolocation permission denied       vikkki.");
        }
      });
    } else {
      console.error("Geolocation is not supported by your browser");
    }
  }, []);
  //   useEffect(() => {
  //     const apiKey = '0631877db9d2db'; // Replace with your actual API key from ipinfo.io
  //     const apiUrl = `https://ipinfo.io?token=${apiKey}`;

  //     axios.get(apiUrl)
  //       .then(response => {
  //         setLocation(response.data);
  //         console.log("iplocation",response.data)
  //       })
  //       .catch(error => {
  //         console.error('Error getting location details:', error.message);
  //       });
  //   }, []);
  return (
    <div className="login-parent-container md:grid md:grid-cols-2 md:gap-4">
      <Helmet>
        <title>
          ColdSender.com Login: Access Your Email Outreach Dashboard
        </title>
        <meta
          name="description"
          content="Seamless access to ColdSender.com. Streamline email outreach, elevate your communication. Log in now!"
        />
      </Helmet>
      <div className="hidden md:block">
        <img
          src={loginImage}
          alt=""
          style={{ width: "50vw", height: "100vh", objectFit: "cover" }}
        />
      </div>

      <div className="loginLayout">
        <div
          style={{
            padding: "0px 12px",
            display: "flex",
            flexDirection: "column",
            gap: "7px",
          }}
        >
          <img
            src={companyLogo}
            alt="rocket"
            style={{ height: "40px", marginBottom: "12px" }}
            loading="lazy"
          />
          
          <div className="loginTypo">Check</div>
          {!apiStatus.status && (
            <p className="emailpasswrong">{apiStatus.message}!</p>
          )}
          {emailStatus.error && passwordStatus.error && (
            <p className="bothRequiredLayout">
              Email address and password is required!
            </p>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <p className="loginEmail">Enter Your Name</p>
            <TextField
              autoComplete="off"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              onClick={() => {
                setEmailStatus({
                  clicked: true,
                  error: false,
                });
                setPasswordStatus({
                  clicked: false,
                  error: false,
                });
              }}
              // value={searchedVal}
              variant="standard"
              placeholder="Enter your name"
              InputProps={{
                disableUnderline: true,
                endAdornment: <div style={{ height: "20px" }}></div>,

                sx: {
                  padding: "10px 16px",
                  gap: "10px",
                  fontSize: "15px",
                  width: "100%",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderRadius: "4px",
                  fontWeight: 400,
                  border: emailStatus.clicked
                    ? "1px solid var(--color-secondary, #3471B8)"
                    : emailStatus.error
                    ? "1px solid var(--color-error, #FF3434)"
                    : "1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  "& input": {
                    color: "var(--color-dark-500, #868686)",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />
          </div>
          <button
            onClick={() => {
           
            }}
            style={{
              width: "100%",
              outline: "none",
              backgroundColor: "#1C485F",
              padding: "10px 16px",
              borderRadius: "4px",
              color: "#FFF",
              fontSize: "14px",
            }}
          >
            {spinner ? (
              <CircularProgress
                style={{
                  color: "var(--color-white, #FFF)",
                  height: "20px",
                  width: "20px",
                }}
              />
            ) : (
              "Check"
            )}
          </button>
         
        </div>
      </div>
    </div>
  );
}
